import anime from "animejs";
import { TypeDirFactor } from "../data";
import Swiper, { SwipeDirs, SwiperEventObj, SwiperEvents } from "./swiper";

export default class Slider {
    private _animating: boolean;
    private _elm: HTMLElement;
    private _swiper: Swiper;
    private _btnPrev: HTMLElement;
    private _btnNext: HTMLElement;

    get target() { return this._elm; }

    constructor(elm: HTMLElement, btnNext: HTMLElement = null, btnPrev: HTMLElement = null) {
        this._elm = elm;
        (this._swiper = new Swiper(this._elm))
            .on(SwiperEvents.Swiping, this._onSwipe.bind(this))
            .on(SwiperEvents.SwipeEnd, this._onSwipe.bind(this));

        if (btnNext)
            (this._btnNext = btnNext).addEventListener("click", () => this.slide(-1));
        if (btnPrev)
            (this._btnPrev = btnPrev).addEventListener("click", () => this.slide(1));

        setTimeout(() => this._elm.scrollLeft = 0, 25);
    }

    private _onSwipe(e: SwiperEventObj) {
        if (e.event == SwiperEvents.Swiping && e.dir != SwipeDirs.None) {
            this._elm.scrollLeft -= e.velocity.x;
            this._elm.style.pointerEvents = "none";
        }
        else if (e.event == SwiperEvents.SwipeEnd) {
            this.slide(e.dir == SwipeDirs.Left ? -1 : (e.dir == SwipeDirs.Right ? 1 : 0), Math.abs(e.velocity.x * 5));
            this._elm.style.pointerEvents = "";
        }
    }

    check() {
        if (this._btnNext) {
            this._btnNext.classList.remove("disabled");
            if (this._elm.scrollLeft < 1)
                this._btnNext.classList.add("disabled");
        }
        if (this._btnPrev) {
            this._btnPrev.classList.remove("disabled");
            if (this._elm.scrollWidth - this._elm.scrollLeft <= this._elm.offsetWidth)
                this._btnPrev.classList.add("disabled");
        }

        this._swiper.enabled = this._elm.scrollWidth > this._elm.offsetWidth;
    }

    slide(dirFactor: TypeDirFactor, amount: number = null) {
        this.check();

        if (this._animating || dirFactor == 0 ||
            (dirFactor == -1 && this._elm.scrollLeft == 0) ||
            (dirFactor == 1 && this._elm.scrollWidth - this._elm.scrollLeft == this._elm.offsetWidth))
            return;

        this._animating = true;
        anime({
            targets: this._elm,
            scrollLeft: this._elm.scrollLeft + dirFactor * (amount == null ? this._elm.offsetWidth : amount),
            duration: 400, easing: "easeOutSine",
            complete: () => {
                this._animating = false;
                this.check();
            }
        });
    }
}